/// <amd-module name="TFS/Samples/MasterDetails/LayerComponents/Commit/CommitDetailsContent" />
import * as React from "react";
import { ICommit } from "../../SampleData";

export const CommitDetailsContent: React.FunctionComponent<{ commit: ICommit }> = props => {
    const { commit } = props;

    return <div>{commit.description}</div>;
};
